import api from './axios';

export const fetchPosCatalog = (branchId) =>
  api.get('/pos/catalog', { params: { branchId } }).then((r) => r.data);

export const fetchPosSales = (params) =>
  api.get('/pos/sales', { params }).then((r) => r.data);

export const createPosSale = (body) =>
  api.post('/pos/sales', body).then((r) => r.data);

export const voidPosSale = (id, reason) =>
  api.post(`/pos/sales/${id}/void`, { reason }).then((r) => r.data);

export const PAYMENT_METHODS = ['CASH', 'CARD', 'BANK_TRANSFER', 'MOBILE', 'OTHER'];
